import { tagRemoteLookupValidators } from "@schemas/remoteLookup/tagRemoteLookupSchema";
import type { TagRemoteLookupId, TagRemoteLookupItem, TagRemoteLookupFilters } from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const tagProvider: RemoteLookupProvider<TagRemoteLookupId, TagRemoteLookupItem, TagRemoteLookupFilters> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: tagRemoteLookupValidators,
};
